import React from 'react';

import { hasAnalysisEvaluationPermission } from '@paragon/login-tools';
import { InlineNotification } from '@paragon/notification-tools';

import { getCheckResultsForActiveLoadCaseAndItem } from '../../../../store/selectors/getCheckResultsForActiveLoadCaseAndItemSelector';
import { useAppSelector } from '../../../hooks';

export function MissingEngineeringVariablesNotification() {
  const checkResults = useAppSelector(getCheckResultsForActiveLoadCaseAndItem);
  const isAnalysisEvaluator = useAppSelector(hasAnalysisEvaluationPermission);
  const hasCheckResultsWithoutVariables =
    checkResults?.length && checkResults.some((checkResult) => checkResult.variables == null);

  if (isAnalysisEvaluator && hasCheckResultsWithoutVariables) {
    return <InlineNotification type="error">Analyze this component to see variables.</InlineNotification>;
  }

  return null;
}
